import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Login from "./components/Login";
import UserProfile from "./components/userProfile/UserProfile";
import CosmeticProfile from "./components/cosmeticProfile/CosmeticProfile";
import { accountService } from "./services/accountService";
import * as imageService from "./services/imageService";
import "./custom.css";
import Register  from "./components/Register";
import Regulations from "./components/Regulations";
import PolicyTerm from "./components/PolicyTerm";
import ResetPassword from "./components/ResetPassword";
import ForgotPassword from "./components/ForgotPassword";
import { User } from "./models/User";
import CookieBanner from "./components/modals/CookieBanner";
import CookiesPolicy from "./components/CookiesPolicy";
import { GoogleOAuthProvider } from '@react-oauth/google';
import PolicyTermApp from "./components/PolicyTermApp";

const App = () => {
  const [user, setUser] = useState<User>();
  const [photoIndex, setPhotoIndex] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  const changeImage = () => {
    const randomNumber = Math.floor(Math.random() * imageService.images.length);
    setPhotoIndex(randomNumber);
  };

  useEffect(() => {
  document.documentElement.classList.add("light-mode");
    const getUserSession = async () => {
      const usr = await accountService.getUser();
      setUser(usr);
      setIsLoading(false);
    };

    getUserSession();
    changeImage();
  }, []);

  return isLoading ? (
    <div />
  ) : (
    <GoogleOAuthProvider clientId="120778782074-v0m6oksbvvfvub8pjqtd6o0dqv89ess5.apps.googleusercontent.com">

    <Layout user={user}>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/register" element={<Register setUser={setUser}/>} />
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/policyterm" element={<PolicyTerm />} />
        <Route path="/policyterm-app" element={<PolicyTermApp />} />
        <Route path="/cookies" element={<CookiesPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/profile/:username" element={<UserProfile />} />
        <Route path="/cosmetic/:name" element={<CosmeticProfile />} />
      </Routes>

      <div className="fixedImage d-none d-sm-block ">
        <img
          src={imageService.images[photoIndex]}
          alt="cosmetic"
          width={200}
          height={200}
          style={{ objectFit: "contain", maxHeight: 500 }}
        />
      </div>
    </Layout>
    </GoogleOAuthProvider>
  );
};

export default App;
